module.exports = __webpack_public_path__ + "static/media/C_Q.64a7365d.png";